import React from "react";
import cashBackImg from "../../assets/img/custom/PizzaMoneyAd.jpg";
import { Container } from "reactstrap";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom";
const CashBack = () => {
  return (
    <div>
      <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
        <IoMdArrowBack /> Go Back
      </button>
      <div className="text-center my-4">
        <a href="https://youtu.be/-m6OIdRKANo" target="_blank">
          https://youtu.be/-m6OIdRKANo
        </a>
      </div>
      <Container>
        <img src={cashBackImg} alt="" className="w-100" />
      </Container>
    </div>
  );
};

export default CashBack;
